"use strict";
exports.__esModule = true;
exports.isValid = void 0;
var srs_1 = require("../../srs");
var utils_1 = require("../../utils");
var pointFactory_1 = require("../pointFactory");
var equals_1 = require("./equals");
var isFilled_1 = require("./isFilled");
var toLatLong_1 = require("./toLatLong");
var INVALID_LAT_LONG_POINT = pointFactory_1.PointFactory.createInstance({ srs: srs_1.DEFAULT_SRS.code, x: 0, y: 90 });
var isValid = function (point) {
    if (!point || !(0, isFilled_1.isFilled)(point))
        return false;
    if (!srs_1.SRSs.getSRSByCode(point.srs))
        return false;
    var pointLatLong = (0, toLatLong_1.toLatLong)(point);
    if (!pointLatLong || (0, equals_1.equals)(pointLatLong, INVALID_LAT_LONG_POINT))
        return false;
    return utils_1.Numbers.between(pointLatLong.x, -180, 180) && utils_1.Numbers.between(pointLatLong.y, -90, 90);
};
exports.isValid = isValid;
//# sourceMappingURL=isValid.js.map